import { downloadFile } from 'src/download_file';
import { Attachment } from '@beunity/design';

Attachment.downloadFile = downloadFile;

export default Attachment;

// Hack for Rails preview:
// customElements.get('ef-attachment') || customElements.define('ef-attachment', Attachment);
